export default '/home/runner/work/swagger-editor/swagger-editor/node_modules/web-tree-sitter'